import React from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Clock, ArrowRight } from "lucide-react";
import { Nav, Footer } from "./Nav";
import { ARTICLES, AFFILIATE_SITEWIDE, AFFILIATE_DISCLOSURE } from "../data/blog";
import { Seo, SITE_URL } from "./Seo";

export function BlogList() {
  return (
    <>
      <Seo title="The Journal" description="Reader-first articles on NLP, coaching, Reiki, rest and personal development — practical wisdom for everyday living." path="/blog" />
      <Nav />
      <section className="hero" style={{ padding: "9rem 0 2.5rem" }}>
        <div className="wrap hero-inner">
          <span className="badge-gold">THE JOURNAL</span>
          <h1 style={{ marginTop: "1rem", fontSize: "clamp(2.2rem,4.4vw,3.6rem)" }}>Wellbeing, in words.</h1>
          <p className="lead">Reader-first articles on NLP, coaching, Reiki, rest and personal development — practical wisdom for everyday living.</p>
        </div>
      </section>
      <section className="sec pad"><div className="wrap">
        <div className="blog-grid">
          {ARTICLES.map((a) => (
            <Link className="blog-card" to={`/blog/${a.id}`} key={a.id}>
              <div className={`art ${a.art}`}><span className={`tag tag-${a.color}`}>{a.tag}</span></div>
              <div className="card-body">
                <h3>{a.title}</h3>
                <p className="desc">{a.excerpt}…</p>
                <div className="chips"><span className="chip"><Clock size={12} /> {a.read} min read</span><span className="chip">{a.category}</span></div>
                <span className="text-btn">Read article <ArrowRight size={13} /></span>
              </div>
            </Link>
          ))}
        </div>
        <p className="muted" style={{ marginTop: "1.5rem", fontSize: ".82rem" }}>{AFFILIATE_SITEWIDE}</p>
      </div></section>
      <Footer />
    </>
  );
}

export function BlogPost() {
  const { id } = useParams();
  const a = ARTICLES.find((x) => x.id === id);
  if (!a) return (<><Nav /><div className="wrap" style={{ padding: "9rem 0" }}><h2>Article not found</h2><Link className="btn btn-primary" to="/blog">Back to blog</Link></div><Footer /></>);
  return (
    <>
      <Seo title={a.title} description={`${a.excerpt}…`} path={`/blog/${a.id}`} type="article"
        jsonLd={{ "@context": "https://schema.org", "@type": "Article", headline: a.title, description: a.excerpt, author: { "@type": "Organization", name: "Ely Wellbeing" }, publisher: { "@type": "Organization", name: "Ely Wellbeing", logo: { "@type": "ImageObject", url: `${SITE_URL}/ely-logo.webp` } }, mainEntityOfPage: `${SITE_URL}/blog/${a.id}` }} />
      <Nav />
      <article className="article">
        <Link className="back-link" to="/blog"><ArrowLeft size={16} /> The Journal</Link>
        <span className={`tag tag-${a.color}`} style={{ display: "inline-block", marginBottom: ".8rem" }}>{a.tag}</span>
        <h1>{a.title}</h1>
        <div className="chips" style={{ margin: ".6rem 0 1.2rem" }}><span className="chip"><Clock size={12} /> {a.read} min read</span><span className="chip">By Ely Wellbeing</span></div>
        <div className="disclosure">{AFFILIATE_DISCLOSURE}</div>
        {a.sections.map((s, i) => (
          <section key={i}>
            {s.h && <h2>{s.h}</h2>}
            {s.paras.map((p, j) => <p key={j}>{p}</p>)}
          </section>
        ))}
        {a.links && a.links.length ? (
          <div className="related">
            <strong>Explore next:</strong>
            <div className="chips" style={{ marginTop: ".5rem" }}>
              {a.links.map((l) => <Link key={l} to="/courses" className="chip">{l}</Link>)}
            </div>
          </div>
        ) : null}
        <p className="muted" style={{ marginTop: "2rem", fontSize: ".8rem", borderTop: "1px solid var(--line)", paddingTop: "1rem" }}>{AFFILIATE_SITEWIDE}</p>
      </article>
      <Footer />
    </>
  );
}
